import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import clsx from 'clsx';

interface LanguageSelectorProps {
  className?: string;
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({ className }) => {
  const { i18n, t } = useTranslation();

  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language);
  };

  return (
    <div className={clsx('relative', className)}>
      <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-xl px-4 py-2 border border-white/20">
        <Globe className="w-5 h-5 text-white" />
        <select
          value={i18n.language}
          onChange={(e) => changeLanguage(e.target.value)}
          className="bg-transparent text-white font-medium focus:outline-none cursor-pointer"
        >
          <option value="es" className="bg-gray-800 text-white">
            🇪🇸 {t('common.spanish')}
          </option>
          <option value="en" className="bg-gray-800 text-white">
            🇺🇸 {t('common.english')}
          </option>
        </select>
      </div>
    </div>
  );
};
